import { render, staticRenderFns } from "./AnsweredQuestions.vue?vue&type=template&id=5b00893a&scoped=true&"
import script from "./AnsweredQuestions.vue?vue&type=script&lang=js&"
export * from "./AnsweredQuestions.vue?vue&type=script&lang=js&"
import style0 from "./AnsweredQuestions.vue?vue&type=style&index=0&id=5b00893a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b00893a",
  null
  
)

export default component.exports